/**
 * Nakładka wyszukiwarki (natywny <dialog>):
 * fokus, Esc, blokada tła i dostępność – z przeglądarki, bez bibliotek.
 */
export const initSearch = () => {
	const overlay = document.querySelector('.js-search-overlay');
	if (!overlay || typeof overlay.showModal !== 'function') return;

	const inner = overlay.querySelector('.js-search-overlay-inner');
	const input = overlay.querySelector('input[type="search"]');
	let trigger = null;

	const open = (btn) => {
		trigger = btn || null;
		overlay.showModal();
		document.querySelectorAll('.js-search-open').forEach((el) => el.setAttribute('aria-expanded', 'true'));
		if (input) {
			input.focus();
			input.select();
		}
	};

	const close = () => {
		if (overlay.open) overlay.close();
	};

	// Otwieranie: przycisk z lupką w menu (może być kilka – desktop i mobile)
	document.addEventListener('click', (e) => {
		const btn = e.target.closest('.js-search-open');
		if (!btn) return;
		e.preventDefault();
		open(btn);
	});

	// Skrót klawiszowy: "/" lub Ctrl/Cmd + K
	document.addEventListener('keydown', (e) => {
		if (overlay.open) return;
		const tag = document.activeElement ? document.activeElement.tagName : '';
		const typing = tag === 'INPUT' || tag === 'TEXTAREA' || (document.activeElement && document.activeElement.isContentEditable);

		if ((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k')) {
			e.preventDefault();
			open(null);
		}
	});

	// Zamykanie: przycisk X lub kliknięcie w tło poza panelem
	overlay.addEventListener('click', (e) => {
		if (e.target === overlay || e.target === inner || e.target.closest('[data-search-close]')) {
			close();
		}
	});

	overlay.addEventListener('close', () => {
		document.querySelectorAll('.js-search-open').forEach((el) => el.setAttribute('aria-expanded', 'false'));
		if (trigger && document.contains(trigger)) trigger.focus();
	});

	// Nie wysyłaj samych spacji
	document.addEventListener('submit', (e) => {
		const form = e.target.closest('.js-search-form');
		if (!form) return;
		const field = form.querySelector('input[name="s"]');
		if (!field) return;

		field.value = field.value.trim();
		if (field.value.length < 2) {
			e.preventDefault();
			field.focus();
		}
	});
};
